'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useEffect, useTransition } from 'react';
import { useRouter, useSearchParams } from 'next/navigation';
import { useContactDetails, useSetOrderType } from '@ordering/stores/OrderStore/hooks';
import { SelectCollectionPointModal } from '@ordering/components/screens/OrderType/components';
import { useTranslations } from 'next-intl';
import { Container } from '@ordering/components/ui/Container';
import { useStorefrontConfig } from '@ordering/providers/StorefrontConfig/StorefrontConfig';
import { useCollectionPointFromUrl } from '@ordering/components/screens/OrderType/hooks/useCollectionPointFromUrl';
import { KioskOrderType } from '@ordering/gql/graphql';
import { hasEmailPrompt, hasSmsPrompt, prefillContactDetails } from '@ordering/utils/hasSmsPrompt';
import { CollectionPoint } from '@ordering/types/Order';
import { Spinner } from '@ordering/components/ui/Spinner';
export const useHandleOrderTypeChange = orderTypes => {
  const $ = _c(10);
  const setOrderTypeInStore = useSetOrderType();
  const [, setContactDetails] = useContactDetails();
  let t0;
  if ($[0] !== setContactDetails) {
    t0 = async orderType => {
      const hasSms = hasSmsPrompt(orderType.customerPrompts);
      const hasEmail = hasEmailPrompt(orderType.customerPrompts);
      const contactDetails = await prefillContactDetails({
        hasSms,
        hasEmail
      });
      if (contactDetails.phoneNumber) {
        setContactDetails(contactDetails.phoneNumber, "phoneNumber");
      }
      if (contactDetails.email) {
        setContactDetails(contactDetails.email, "email");
      }
    };
    $[0] = setContactDetails;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const prefillSavedContactDetails = t0;
  let t1;
  if ($[2] !== prefillSavedContactDetails || $[3] !== setOrderTypeInStore) {
    t1 = async (orderType_0, collectionPoint) => {
      setOrderTypeInStore({
        id: orderType_0.id,
        name: orderType_0.name,
        type: orderType_0.type,
        priceBookId: orderType_0.priceBook.id,
        collectionPoint,
        customerOrderInfo: {}
      });
      await prefillSavedContactDetails(orderType_0);
    };
    $[2] = prefillSavedContactDetails;
    $[3] = setOrderTypeInStore;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const handleOrderTypeChange = t1;
  let t2;
  if ($[5] !== handleOrderTypeChange || $[6] !== orderTypes) {
    t2 = {
      orderTypes,
      setOrderType: handleOrderTypeChange
    };
    $[5] = handleOrderTypeChange;
    $[6] = orderTypes;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  useCollectionPointFromUrl(t2);
  let t3;
  if ($[8] !== handleOrderTypeChange) {
    t3 = {
      setOrderType: handleOrderTypeChange
    };
    $[8] = handleOrderTypeChange;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};
const OrderTypeSelector = () => {
  const $ = _c(47);
  const {
    orderPreferences
  } = useStorefrontConfig();
  const t = useTranslations();
  const router = useRouter();
  const [selectedOrderTypeId, setSelectedOrderTypeId] = React.useState();
  const [loadingOrderTypeId, setLoadingOrderTypeId] = React.useState(null);
  const [isPending, startTransition] = useTransition();
  const {
    setOrderType
  } = useHandleOrderTypeChange(orderPreferences.orderTypes);
  let t0;
  let t1;
  if ($[0] !== router) {
    t0 = () => {
      router.prefetch("menu");
    };
    t1 = [router];
    $[0] = router;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] !== orderPreferences.orderTypes || $[4] !== router || $[5] !== setOrderType) {
    t2 = orderTypeId => {
      const configOrderTypes = orderPreferences.orderTypes;
      const configOrderType = configOrderTypes.find(type => type.id === orderTypeId);
      if (!configOrderType) {
        return;
      }
      const collectionPoints = configOrderType.collectionPoints;
      const collectionPoint = collectionPoints[0];
      if (collectionPoints.length > 1) {
        setSelectedOrderTypeId(orderTypeId);
      } else {
        setLoadingOrderTypeId(orderTypeId);
        startTransition(async () => {
          await setOrderType(configOrderType, collectionPoint ?? null);
          router.push("menu");
        });
      }
    };
    $[3] = orderPreferences.orderTypes;
    $[4] = router;
    $[5] = setOrderType;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const handleSelectOrderType = t2;
  let t3;
  if ($[7] !== orderPreferences.orderTypes || $[8] !== router || $[9] !== selectedOrderTypeId || $[10] !== setOrderType) {
    t3 = collectionPointId => {
      const configOrderTypes_0 = orderPreferences.orderTypes;
      const configOrderType_0 = configOrderTypes_0.find(type_0 => type_0.id === selectedOrderTypeId);
      if (!configOrderType_0) {
        return;
      }
      const collectionPoint_0 = configOrderType_0.collectionPoints.find(point => point.id === collectionPointId);
      if (!collectionPoint_0) {
        return;
      }
      setLoadingOrderTypeId(selectedOrderTypeId ?? null);
      startTransition(async () => {
        await setOrderType(configOrderType_0, collectionPoint_0);
        router.push("menu");
      });
    };
    $[7] = orderPreferences.orderTypes;
    $[8] = router;
    $[9] = selectedOrderTypeId;
    $[10] = setOrderType;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const handleSelectCollectionPointId = t3;
  let t4;
  bb0: {
    if (!selectedOrderTypeId) {
      t4 = undefined;
      break bb0;
    }
    const configOrderTypes_1 = orderPreferences.orderTypes;
    let t5;
    if ($[12] !== configOrderTypes_1 || $[13] !== selectedOrderTypeId) {
      let t6;
      if ($[15] !== selectedOrderTypeId) {
        t6 = type_1 => type_1.id === selectedOrderTypeId;
        $[15] = selectedOrderTypeId;
        $[16] = t6;
      } else {
        t6 = $[16];
      }
      t5 = configOrderTypes_1.find(t6);
      $[12] = configOrderTypes_1;
      $[13] = selectedOrderTypeId;
      $[14] = t5;
    } else {
      t5 = $[14];
    }
    t4 = t5;
  }
  const selectedOrderType = t4;
  let t5;
  if ($[17] !== t) {
    t5 = t("order_type_page.title");
    $[17] = t;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== t5) {
    t6 = <h1 className="text-center text-brand-primary-foreground text-[24px] font-bold leading-[28px] ">{t5}</h1>;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== handleSelectOrderType || $[22] !== isPending || $[23] !== loadingOrderTypeId || $[24] !== orderPreferences.orderTypes) {
    let t8;
    if ($[26] !== handleSelectOrderType || $[27] !== isPending || $[28] !== loadingOrderTypeId) {
      t8 = orderType => {
        const isLoading = isPending && loadingOrderTypeId === orderType.id;
        return <button key={`ordertype-${orderType.id}`} className={"flex items-center justify-between border-border border rounded-[8px] bg-background p-4 text-left text-primary \n              md:w-[300px] md:h-[98px] disabled:opacity-50 disabled:pointer-events-none"} onClick={() => handleSelectOrderType(orderType.id)} disabled={isPending}><div><p className="text-[16px] leading-[24px] font-bold">{orderType.name}</p><p className="text-[12px] leading-[16px]">{orderType.description}</p></div>{isLoading && <Spinner className="shrink-0 ml-2" />}</button>;
      };
      $[26] = handleSelectOrderType;
      $[27] = isPending;
      $[28] = loadingOrderTypeId;
      $[29] = t8;
    } else {
      t8 = $[29];
    }
    t7 = orderPreferences.orderTypes.map(t8);
    $[21] = handleSelectOrderType;
    $[22] = isPending;
    $[23] = loadingOrderTypeId;
    $[24] = orderPreferences.orderTypes;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  let t8;
  if ($[30] !== t7) {
    t8 = <div className="mt-4 pt-4 pb-8 flex flex-col md:flex-row md:justify-center gap-4 min-h-0 overflow-y-auto ">{t7}</div>;
    $[30] = t7;
    $[31] = t8;
  } else {
    t8 = $[31];
  }
  let t9;
  if ($[32] !== t6 || $[33] !== t8) {
    t9 = <Container className="bg-brand-primary-background h-screen flex flex-col justify-center overflow-y-hidden mx-auto">{t6}{t8}</Container>;
    $[32] = t6;
    $[33] = t8;
    $[34] = t9;
  } else {
    t9 = $[34];
  }
  const t10 = !!selectedOrderTypeId;
  let t11;
  if ($[35] !== handleSelectCollectionPointId) {
    t11 = collectionPointId_0 => handleSelectCollectionPointId(collectionPointId_0);
    $[35] = handleSelectCollectionPointId;
    $[36] = t11;
  } else {
    t11 = $[36];
  }
  let t12;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = () => setSelectedOrderTypeId(undefined);
    $[37] = t12;
  } else {
    t12 = $[37];
  }
  let t13;
  if ($[38] !== selectedOrderType?.collectionPoints) {
    t13 = selectedOrderType?.collectionPoints ?? [];
    $[38] = selectedOrderType?.collectionPoints;
    $[39] = t13;
  } else {
    t13 = $[39];
  }
  let t14;
  if ($[40] !== t10 || $[41] !== t11 || $[42] !== t13) {
    t14 = <SelectCollectionPointModal isOpen={t10} selectCollectionPointId={t11} handleClose={t12} collectionPoints={t13} />;
    $[40] = t10;
    $[41] = t11;
    $[42] = t13;
    $[43] = t14;
  } else {
    t14 = $[43];
  }
  let t15;
  if ($[44] !== t14 || $[45] !== t9) {
    t15 = <div className="bg-brand-primary-background">{t9}{t14}</div>;
    $[44] = t14;
    $[45] = t9;
    $[46] = t15;
  } else {
    t15 = $[46];
  }
  return t15;
};
export const OrderTypeSelectorPage = () => {
  const $ = _c(24);
  const t = useTranslations();
  const router = useRouter();
  const searchParams = useSearchParams();
  const {
    orderPreferences
  } = useStorefrontConfig();
  const {
    setOrderType
  } = useHandleOrderTypeChange(orderPreferences.orderTypes);
  const hasOneOrderType = orderPreferences.orderTypes.length === 1;
  let t0;
  if ($[0] !== searchParams) {
    t0 = searchParams.get("cpt");
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const hasCollectionPointId = !!t0;
  let t1;
  if ($[2] !== hasCollectionPointId || $[3] !== hasOneOrderType || $[4] !== orderPreferences.orderTypes[0] || $[5] !== router || $[6] !== setOrderType) {
    t1 = () => {
      if (hasOneOrderType && !hasCollectionPointId) {
        const orderType = orderPreferences.orderTypes[0];
        if (orderType) {
          setOrderType(orderType, null);
          router.push("menu");
        }
      }
    };
    $[2] = hasCollectionPointId;
    $[3] = hasOneOrderType;
    $[4] = orderPreferences.orderTypes[0];
    $[5] = router;
    $[6] = setOrderType;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== hasCollectionPointId || $[9] !== hasOneOrderType || $[10] !== orderPreferences || $[11] !== router || $[12] !== setOrderType) {
    t2 = [hasOneOrderType, orderPreferences, router, setOrderType, hasCollectionPointId];
    $[8] = hasCollectionPointId;
    $[9] = hasOneOrderType;
    $[10] = orderPreferences;
    $[11] = router;
    $[12] = setOrderType;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  useEffect(t1, t2);
  if (hasOneOrderType) {
    let t3;
    if ($[14] !== t) {
      t3 = t("global.welcome");
      $[14] = t;
      $[15] = t3;
    } else {
      t3 = $[15];
    }
    let t4;
    if ($[16] !== t3) {
      t4 = <h1 className="text-center text-brand-primary-foreground text-[24px] font-bold leading-[28px] ">{t3}</h1>;
      $[16] = t3;
      $[17] = t4;
    } else {
      t4 = $[17];
    }
    let t5;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <span className="inline-block bg-brand-primary-foreground w-2 h-2 rounded-full mr-1 animate-jump" style={{
        animationDelay: "200ms"
      }} />;
      $[18] = t5;
    } else {
      t5 = $[18];
    }
    let t6;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <span className="inline-block bg-brand-primary-foreground w-2 h-2 rounded-full mr-1 animate-jump" style={{
        animationDelay: "400ms"
      }} />;
      $[19] = t6;
    } else {
      t6 = $[19];
    }
    let t7;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = <div className="flex items-center justify-center"><span className="flex jumping-dots">{t5}{t6}<span className="inline-block bg-brand-primary-foreground w-2 h-2 rounded-full mr-1 animate-jump" style={{
            animationDelay: "600ms"
          }} /></span></div>;
      $[20] = t7;
    } else {
      t7 = $[20];
    }
    let t8;
    if ($[21] !== t4) {
      t8 = <div className="bg-brand-primary-background"><Container className="bg-brand-primary-background h-screen p-4 flex flex-col justify-center overflow-y-hidden gap-6 mx-auto">{t4}{t7}</Container></div>;
      $[21] = t4;
      $[22] = t8;
    } else {
      t8 = $[22];
    }
    return t8;
  }
  let t3;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <OrderTypeSelector />;
    $[23] = t3;
  } else {
    t3 = $[23];
  }
  return t3;
};